import { render, staticRenderFns } from "./requestNumberReports.vue?vue&type=template&id=4960b752&scoped=true"
import script from "./requestNumberReports.vue?vue&type=script&lang=js"
export * from "./requestNumberReports.vue?vue&type=script&lang=js"
import style0 from "./requestNumberReports.vue?vue&type=style&index=0&id=4960b752&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4960b752",
  null
  
)

export default component.exports